export function buttonUp(): void {

    var btnUp = document.querySelector(".btn-up");
    if (!btnUp) { return; }

    btnUp.addEventListener("click", () => window.scrollTo({
        top: 0,
        behavior: 'smooth'
    }));
};